import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { PlaylistService } from '../../../../services/playlist/playlist.service';
import { SocialMediaPostForBoard} from '../../../../modele/boardModel';
import { ShowhideService } from '../../../../services/showhide/showhide.service';



@Component({
  selector: 'app-playlist-content',
  templateUrl: './playlist-content.component.html',
  styleUrls: ['./playlist-content.component.scss']
})
export class PlaylistContentComponent implements OnInit {
    private trackslist:Array<SocialMediaPostForBoard>=[];
    playThisItem: any;
    playThisItemVideoName: string;
    showVideo:boolean = false;
    tracksInPlaylist: number;
    autoplay: string = "?autoplay=1";
    isPlaylistOpen:boolean;
    parent: string = "&parent=whooosh.com";
    itemHeight: string = "113px"
    itemWidth: string = "200px"



  constructor(
      private playlistService: PlaylistService,
      private nav: ShowhideService,


  ) {
      this.nav.openPlaylistEmitter().subscribe((new_click => {
          this.isPlaylistOpen = new_click
      }))
      this.playlistService.getPlaylistEmitter().subscribe(items=>{
          this.tracksInPlaylist = items.length
          this.trackslist = items
          setTimeout(() => {
              this.showVideo = true
          }, 1500);
      })
      this.playlistService.getAktivTrackFromPlaylistEmitter().subscribe(track=>{
          if(track.id == 12){
              this.playThisItem = track.url + this.parent
              this.playThisItemVideoName = track.text
              setTimeout(() => {
                  this.showVideo = true
              }, 1500);
          }
          else{
              this.playThisItem = track.url + this.autoplay
              this.playThisItemVideoName = track.text
              setTimeout(() => {
                  this.showVideo = true
              }, 1500);
          }
      })
  }
  ngOnInit() {
  }
  setMyStyles2() {
      let styles = {
          'position': 'fixed',
          'z-index':'5',
          'top': '130px',
          'left': '0px',
          'height': this.itemHeight,
          'width':this.itemWidth,
      };
      return styles;
  }
  setMyStyles3() {
      let styles = {
          'height': this.itemHeight,
          'width':this.itemWidth,
      };
      return styles;
  }
  resize(height, width){
      this.itemHeight = height;
      this.itemWidth = width;
  }
  addtoPlaylist(item){
      this.playlistService.addTrackToPlaylist(item);
  }
  sendClickPlaylist(){
          this.nav.openPlaylistOnClick(false);
  }


}
